export const ACTIVE_COLOR = '#72BF44';
export const INACTIVE_COLOR = '#CCCCCC';
export const HOVER_COLOR = '#FFFFFF';
